import { jsx as _jsx } from "react/jsx-runtime";
export const ChevronDownS = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20.7711 7.21307C21.0497 7.48356 21.0734 7.9179 20.8375 8.21601L12.5396 16.7737C12.3984 16.9191 12.2042 17.0011 12.0015 17.0012C11.7987 17.0012 11.6037 16.9192 11.4624 16.7737L3.16256 8.21601C2.92645 7.91787 2.95021 7.48363 3.22897 7.21307C3.52621 6.9247 4.00107 6.93151 4.28952 7.2287L12.0015 15.1731L19.7662 7.17694C20.0571 6.93192 20.4923 6.94254 20.7711 7.21307Z",
            fill: color
        })
    });

//# sourceMappingURL=chevron-down-s.js.map